var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiamiInternationalAutodrome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 702.5",
    style: {
      enableBackground: "new 0 0 1080 702.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:9.1721;stroke-miterlimit:15.118;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:3.0525;stroke-miterlimit:15.118;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{font-family:'Bull-Heavy1';}\n\t.st4{font-size:18.4813px;}\n\t.st5{font-size:19.8861px;}\n\t.st6{fill:#010101;}\n\t.st7{opacity:0.8;}\n\t.st8{opacity:0.9;}\n\t.st9{opacity:0.7;}\n\t.st10{opacity:0.6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M433.9,297.1c22.2,11.9,66.6,35.7,102.6,55c36,19.3,63.5,34.2,77.9,42c14.5,7.9,15.9,8.8,17.4,9.8 c1.5,1.1,3,2.3,4.3,3.7c1.3,1.4,2.5,2.9,3.4,4.2c0.9,1.3,1.4,2.4,1.9,4.1c0.4,1.7,0.8,3.9,0.8,5.7c0,1.9-0.4,3.4-1.1,4.8 c-0.7,1.5-1.6,2.9-3,4.5c-1.4,1.6-3.3,3.2-5.9,5.2c-2.6,2-6,4.4-9.1,6.7c-3.2,2.3-6.2,4.4-8.3,6.1c-2.1,1.7-3.3,3-4.5,4.4 c-1.1,1.4-2.2,2.9-3.2,4.7c-1,1.8-1.9,3.8-2.6,6.3c-0.7,2.5-1.2,5.5-1.2,11.9c0,6.4,0.4,16.2,0.5,22.1c0.1,5.8-0.2,7.7-0.9,10.1 c-0.7,2.4-1.7,5.4-2.9,8.1s-2.5,5-3.9,6.9c-1.3,1.9-2.6,3.2-4,4.6c-1.4,1.4-3,2.8-5,4.5c-2,1.7-4.4,3.6-7.2,5.4 c-2.9,1.9-6.2,3.7-9.5,5.4c-3.2,1.6-6.3,3.1-10,4.7c-3.7,1.6-8,3.3-12.4,4.8c-4.3,1.5-8.6,2.6-12.6,3.5c-4,0.9-7.6,1.4-14.5,1.9 c-7,0.5-17.3,1-24.3,1.1c-7,0.1-10.7-0.2-14-0.7c-3.4-0.5-6.4-1.1-10.1-2.2c-3.7-1.1-8.2-2.6-13.2-4.6c-5-2-10.6-4.4-33.9-16.5 c-23.3-12.1-64.4-33.9-86.7-45.6c-22.3-11.7-25.8-13.4-28.7-14.7c-2.9-1.3-5.3-2.3-8.2-3c-2.9-0.8-6.3-1.4-9.2-1.8 c-2.8-0.4-5.1-0.6-7.6-0.5c-2.5,0.1-5.2,0.5-7.7,0.9c-2.5,0.4-4.7,0.9-7.5,1.9c-2.8,1-6.2,2.6-9.7,4.5s-7,4.1-10.8,6.5 c-3.8,2.5-7.9,5.2-11.6,7.8c-3.7,2.6-7,5-9.8,6.7c-2.8,1.7-5.1,2.8-7.7,3.7c-2.6,0.9-5.6,1.6-9.9,2.1c-4.3,0.4-9.8,0.5-14,0.3 c-4.2-0.2-6.9-0.8-9.8-1.8c-2.9-1-5.9-2.5-9.2-4.8c-3.4-2.2-7-5.2-11-8.5s-8-7-11.4-9.8c-3.4-2.8-6-4.7-9.3-6.6 c-3.3-1.9-7.2-3.7-10.7-5c-3.5-1.3-6.7-2.2-9.8-2.6c-3.1-0.4-6-0.4-9.4-0.1c-3.4,0.2-7.3,0.7-11.2,1.6c-3.9,0.9-7.9,2.2-12,3.8 c-4.1,1.6-8.5,3.6-12.3,5.5c-3.8,1.9-7.2,3.8-10.4,6c-3.2,2.2-6.3,4.8-9.1,7.3c-2.8,2.6-5.3,5.1-7.5,8.1c-2.1,3-3.9,6.5-5.1,9.5 c-1.3,3.1-2.1,5.7-2.6,7.9c-0.6,2.1-0.9,3.7-0.9,6.9c0,3.2,0.4,7.9,0.9,11.1c0.4,3.2,0.9,4.8,2,6.7c1.1,1.9,2.9,4.2,5,6.2 c2.1,2,4.6,3.8,7,5.1c2.4,1.3,4.8,2.2,7.3,2.8c2.5,0.6,5.2,0.8,7.9,0.7c2.8-0.1,5.7-0.4,8.7-1.1c3-0.7,6-1.6,10-2.4 c4-0.7,8.8-1.2,14-1.2c5.1,0,10.5,0.3,15.8,0.9c5.3,0.6,10.6,1.4,18.7,3c8.1,1.6,18.9,4.1,26.9,5.8c8,1.7,13.2,2.7,20.4,3.4 c7.2,0.8,16.4,1.3,22.2,1.6c5.9,0.3,8.4,0.3,33.4-1.3c25-1.6,72.4-4.7,100.4-6.2c28-1.6,36.6-1.6,43.5-1.5c6.9,0.2,12,0.6,16.8,1.2 c4.8,0.6,9.3,1.4,14,2.5s9.7,2.5,15.2,4.5c5.5,2,11.7,4.6,17.8,7c6.1,2.4,12.2,4.7,18.1,6.8c5.8,2.1,11.3,4,16.1,5.6 c4.7,1.6,8.7,2.8,13.9,4.1c5.2,1.3,11.7,2.7,17.3,3.6s10.4,1.5,16.1,2c5.8,0.5,12.6,0.9,22.2,0.7c9.6-0.1,22-0.9,30.6-1.5 c8.6-0.7,13.4-1.2,19.9-2.3c6.5-1,14.8-2.5,23.9-4.5c9-1.9,18.8-4.3,27.8-6.8c9-2.5,17.1-5.2,29.6-9.9s29.2-11.4,47.6-18.9 c18.4-7.5,38.6-15.9,52-21.4c13.5-5.5,20.3-8.2,29.1-12.2c8.9-4,19.8-9.3,33.7-16.4c13.9-7.1,30.7-15.9,44.9-23.7 c14.1-7.7,25.5-14.3,32.2-18.6c6.7-4.2,8.7-6.1,10.2-7.8c1.5-1.7,2.6-3.2,3.2-4.8c0.6-1.5,0.8-3.1,0.6-4.6 c-0.2-1.5-0.7-2.8-2.1-4.4s-3.6-3.7-7.5-6.3c-3.9-2.7-9.5-6-13.2-8c-3.7-2.1-5.5-2.8-7.6-4.1c-2.1-1.2-4.6-2.9-6.8-4.8 c-2.2-2-4.1-4.2-5.5-6.4c-1.4-2.2-2.3-4.2-2.9-6.6c-0.6-2.4-1-5-0.9-7.7c0.1-2.7,0.6-5.4,1.5-8.2c0.9-2.7,2.1-5.5,3.6-8 c1.5-2.5,3.3-4.6,5.6-6.4c2.3-1.8,5.1-3.2,13.2-4.1c8.1-1,21.5-1.5,29.1-2.1c7.6-0.6,9.4-1.2,11.6-2.3c2.2-1.1,4.7-2.6,7.1-4.3 c2.3-1.7,4.4-3.5,8.1-8.8s8.8-14.1,11.5-18.9c2.7-4.8,2.9-5.6,2.8-6.5c-0.1-0.9-0.5-1.9-1.3-2.9c-0.8-0.9-2-1.8-3.3-2.4 c-1.3-0.7-2.6-1.2-3.8-1.8c-1.1-0.6-2.1-1.4-2.9-2.1c-0.8-0.7-1.3-1.5-1.6-2.7c-0.3-1.2-0.5-3-0.4-5c0.1-2,0.3-4.3,1.2-8.5 c0.9-4.2,2.5-10.4,3.7-15.3c1.2-4.8,2.1-8.3,2.6-11.5c0.5-3.2,0.7-6.1,0.7-7.8c0-1.8-0.2-2.4-0.6-3.3c-0.4-0.9-1.1-2.2-2-3.1 c-0.9-1-1.9-1.7-3.3-2.1c-1.4-0.4-3.1-0.6-140-0.7c-136.9-0.1-408.8-0.1-545-0.1c-136.2,0-136.6,0.1-137.3,0.3 c-0.7,0.3-1.6,0.8-2.5,1.3c-0.9,0.5-1.7,1.2-2.6,2.3c-0.9,1.1-1.8,2.8-2.4,4.2s-0.7,2.7-0.7,4.1c0.1,1.4,0.4,3,1,4.5 c0.6,1.5,1.4,2.9,2.9,4.4c1.5,1.5,3.7,3.3,10.4,7.7s18.1,11.7,25.4,15.9c7.3,4.3,10.4,5.5,14,6.6c3.6,1,7.7,1.8,11.7,2.2 c4.1,0.5,8.1,0.6,12.8,0.3c4.7-0.3,10.1-1.2,15.3-2.6c5.2-1.4,10.3-3.3,14.3-5.4c4.1-2,7.1-4.2,10.7-6.6c3.6-2.4,7.6-5.1,12.6-7.6 c4.9-2.6,10.7-5,17.2-7.4c6.5-2.3,13.5-4.5,19.6-6c6.1-1.5,11.1-2.3,17.3-2.7c6.2-0.5,13.5-0.6,19.7-0.5c6.2,0.1,11.3,0.6,16.8,1.6 c5.5,1,11.4,2.6,17,4.4c5.6,1.9,10.9,4,15,5.9c4.1,1.9,7.2,3.5,8.7,4.3C411.7,285.2,411.7,285.2,433.9,297.1L433.9,297.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M259.7,296.8c35.9-9.4,71.2-17.7,107.7-11.1c37.4,6.9,72.7,30.3,105.8,48.3c32.8,18,66.1,35.3,99.6,52 c14.4,7.2,37.1,16,40.5,33.7c2.6,14.1-7,30.4-8.8,44.7"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 658.4702 430.4362)",
    className: "st2 st3 st4"
  }, "T1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 569.4067 467.3005)",
    className: "st2 st3 st4"
  }, "T2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 604.4028 544.6609)",
    className: "st2 st3 st4"
  }, "T3"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 278.4995 454.007)",
    className: "st2 st3 st4"
  }, "T4"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 188.7583 532.571)",
    className: "st2 st3 st4"
  }, "T5"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 103.1182 450.3791)",
    className: "st2 st3 st4"
  }, "T6"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 56.7456 522.9021)",
    className: "st2 st3 st4"
  }, "T7"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 64.8648 583.3352)",
    className: "st2 st3 st4"
  }, "T8"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 389.4478 584.4451)",
    className: "st2 st3 st4"
  }, "T9"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 527.5708 580.8323)",
    className: "st2 st3 st4"
  }, "T10"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 965.1958 454.007)",
    className: "st2 st3 st4"
  }, "T11"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 854.1899 399.615)",
    className: "st2 st3 st4"
  }, "T12"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 969.5649 382.0852)",
    className: "st2 st3 st4"
  }, "T13"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 996.2261 349.6277)",
    className: "st2 st3 st5"
  }, "T14"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 936.562 325.8825)",
    className: "st2 st3 st4"
  }, "T15"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 941.9507 278.1399)",
    className: "st2 st3 st4"
  }, "T16"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 107.1406 264.3816)",
    className: "st2 st3 st4"
  }, "T17"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 197.4536 333.2727)",
    className: "st2 st3 st4"
  }, "T18"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 337.2027 311.0261)",
    className: "st2 st3 st4"
  }, "T19"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M504.4,323.9l1.6-3.1l3.1,1.6l-1.6,3.1L504.4,323.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M507.5,325.5l1.6-3.1l3.1,1.6l-1.6,3.1L507.5,325.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M510.6,327.1l1.6-3.1l3.1,1.6l-1.6,3.1L510.6,327.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M506,320.8l1.6-3.1l3.1,1.6l-1.6,3.1L506,320.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M512.2,324.1l1.6-3.1l3.1,1.6l-1.6,3.1L512.2,324.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M509.1,322.5l1.6-3.1l3.1,1.6l-1.6,3.1L509.1,322.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M507.6,317.8l1.6-3.1l3.1,1.6l-1.6,3.1L507.6,317.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M510.8,319.4l1.6-3.1l3.1,1.6l-1.6,3.1L510.8,319.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M513.9,321l1.6-3.1l3.1,1.6l-1.6,3.1L513.9,321z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M509.2,314.7l1.6-3.1l3.1,1.6l-1.6,3.1L509.2,314.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M515.5,317.9l1.6-3.1l3.1,1.6l-1.6,3.1L515.5,317.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M512.3,316.3l1.6-3.1l3.1,1.6l-1.6,3.1L512.3,316.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M510.7,311.6l1.6-3.1l3.1,1.6l-1.6,3.1L510.7,311.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M513.8,313.2l1.6-3.1l3.1,1.6l-1.6,3.1L513.8,313.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M516.9,314.9l1.6-3.1l3.1,1.6l-1.6,3.1L516.9,314.9z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "539.7,332.7 537.4,325.2 533.9,323.3 536.2,330.8 528.7,333.2 532.2,335  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "545.7,335.7 543.3,328.2 539.8,326.3 542.1,333.9 534.6,336.2 538.1,338.1  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "551.6,338.9 549.3,331.3 545.8,329.5 548.1,337 540.6,339.4 544.1,341.2  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "531.8,322.2 528.3,320.4 530.7,327.9 523.1,330.3 526.6,332.1 534.2,329.8  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "526.3,319.3 522.8,317.5 525.1,325 517.6,327.4 521.1,329.2 528.6,326.9  "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiamiInternationalAutodrome);
export default __webpack_public_path__ + "static/media/miami_international_autodrome.5d9730bd6de9283999bdd9b0e71b291a.svg";
export { ForwardRef as ReactComponent };